<template>
  <div>
    <DxDataGrid :ref="dataGridRef" :data-source="dataSource" :remote-operations="true" :show-borders="true"
      :show-row-lines="true" :allow-column-resizing="true" :column-auto-width="true" :allow-column-reordering="true"
      :height="600">
      <DxLoadPanel :enabled="true" />
      <DxExport :enabled="true" />
      <DxColumnChooser :enabled="true" />
      <DxPaging :page-size="20" />
      <DxPager :show-page-size-selector="true" :allowed-page-sizes="[20, 50, 100]" />
      <DxGroupPanel :visible="true" />
      <DxGrouping :auto-expand-all="true" />
      <DxSearchPanel :visible="true" />

      <dx-column v-for="column in viewConfig.columns" v-bind:key="column.fieldName" :data-field="column.fieldName"
        :caption="column.caption" :data-type="getDataType(column.dataType)" :width="column.widths"
        :group-index="column.groupIndex" />

      <DxToolbar>
        <DxItem location="before" name="columnChooserButton" />
        <DxItem location="before" name="groupPanel" />
        <DxItem location="after" name="searchPanel" />
        <DxItem location="after" name="exportButton" />
        <DxItem location="after" template="toolbarPdfTemplate" />
      </DxToolbar>
      <template #toolbarPdfTemplate>
        <DxButton icon="exportpdf" text="Export to PDF" @click="exportGrid()" />
      </template>
    </DxDataGrid>
  </div>
</template>

<script>

import { jsPDF } from "jspdf";
import "jspdf-autotable";
import { exportDataGrid as exportDataGridToPdf } from "devextreme/pdf_exporter";

import DxButton from "devextreme-vue/button";
import {
  DxDataGrid,
  DxExport,
  DxColumnChooser,
  DxColumn,
  DxPaging,
  DxPager,
  DxLoadPanel,
  DxToolbar,
  DxItem,
  DxGrouping,
  DxGroupPanel,
  DxSearchPanel,
} from "devextreme-vue/data-grid";
import CustomStore from "devextreme/data/custom_store";

import Api from "@/api";

const dataGridRef = "dataGrid";

function isNotEmpty(value) {
  return value !== undefined && value !== null && value !== '';
}

export default {
  props: ["viewId", "viewConfig"],
  components: {
    DxDataGrid,
    DxExport,
    DxColumnChooser,
    DxColumn,
    DxPaging,
    DxPager,
    DxLoadPanel,
    DxToolbar,
    DxItem,
    DxButton,
    DxGrouping,
    DxGroupPanel,
    DxSearchPanel,
  },
  data: () => ({
    dataGridRef,
  }),
  computed: {
    dataGrid() {
      return this.$refs[dataGridRef].instance;
    },

    dataSource() {
      let viewId = this.viewId;

      return new CustomStore({
        load(loadOptions) {

          let params = '?';
          [
            'skip',
            'take',
            'requireTotalCount',
            'requireGroupCount',
            'sort',
            'filter',
            'totalSummary',
            'group',
            'groupSummary',
          ].forEach((i) => {
            if (i in loadOptions && isNotEmpty(loadOptions[i])) { params += `${i}=${JSON.stringify(loadOptions[i])}&`; }
          });

          params = params.slice(0, -1);

          return Api.getDataGridData(viewId, params).then((data) => ({
            data: data.data,
            totalCount: data.totalCount,
            groupCount: data.pageSize,
          }));
        },
      });
    }
  },
  methods: {
    getDataType(value) {
      let columnTypes = ["string", "date", "number", "number"]

      return columnTypes[value];
    },

    exportGrid() {
      const doc = new jsPDF();
      exportDataGridToPdf({
        jsPDFDocument: doc,
        component: this.dataGrid,
      }).then(() => {
        doc.save("data.pdf");
      });
    },
  }
}
</script>